<!-- page starts-->
    <section class="page-wrapper">
      <div class="ashton-hero-top-detail payment cf">
         <div class="container">
            <div class="ashton-hero-top-payment-section cf">
            	<div class="ashton-hero-top-payment-left">
            		<div class="ashton-hero-top-payment-image-box">
            			<h3>Payment</h3>
            			<div class="ashton-hero-top-payment-image-slide">
            				<ngx-slick-carousel class="carousel " #slickModal="slick-carousel" [config]="slidepaymentConfig">
	            				<div ngxSlickItem class="ashton-hero-top-payment-image slide">
		            				<div class="ashton-hero-top-payment-card-name">
		            					<h3>visa</h3>
		            				</div>
		            				<div class="ashton-hero-top-payment-card-number">
		            					<p>9823 1256 0099 3212</p>
		            				</div>
		            				<div class="ashton-hero-top-payment-card-date-detail">
		            					<div class="ashton-hero-top-payment-card-holder-name">
		            						<p>Card Holder</p>
		            						<h3>John Smith</h3>
		            					</div>
		            					<div class="ashton-hero-top-payment-card-holder-valid-date">
		            						<p>Valid Throu</p>
		            						<h3>11/23</h3>
		            					</div>
		            				</div>
		            			</div>
		            			<div ngxSlickItem class="ashton-hero-top-payment-image slide">
		            				<div class="ashton-hero-top-payment-card-name">
		            					<h3>visa</h3>
		            				</div>
		            				<div class="ashton-hero-top-payment-card-number">
		            					<p>9823 1256 0099 3212</p>
		            				</div>
		            				<div class="ashton-hero-top-payment-card-date-detail">
		            					<div class="ashton-hero-top-payment-card-holder-name">
		            						<p>Card Holder</p>
		            						<h3>John Smith</h3>
		            					</div>
		            					<div class="ashton-hero-top-payment-card-holder-valid-date">
		            						<p>Valid Throu</p>
		            						<h3>11/23</h3>
		            					</div>
		            				</div>
		            			</div>
		            			<div ngxSlickItem class="ashton-hero-top-payment-image slide">
		            				<div class="ashton-hero-top-payment-card-name">
		            					<h3>visa</h3>
		            				</div>
		            				<div class="ashton-hero-top-payment-card-number">
		            					<p>9823 1256 0099 3212</p>
		            				</div>
		            				<div class="ashton-hero-top-payment-card-date-detail">
		            					<div class="ashton-hero-top-payment-card-holder-name">
		            						<p>Card Holder</p>
		            						<h3>John Smith</h3>
		            					</div>
		            					<div class="ashton-hero-top-payment-card-holder-valid-date">
		            						<p>Valid Throu</p>
		            						<h3>11/23</h3>
		            					</div>
		            				</div>
		            			</div>
		            		</ngx-slick-carousel>
            			</div>
            		</div>
            	</div>
            	<div class="ashton-hero-top-payment-right">
            		<h3>Add Card</h3>
            		<div class="ashton-hero-top-payment-add-card-detail">
	                    <div class="checkout-address-box full">
	                      <input type="text" name="" placeholder="Card Holder Name" class="input-style"> 
	                    </div>
	                    <div class="checkout-address-box full">
	                      <input type="text" name="" placeholder="Card Number" class="input-style"> 
	                    </div>
	                    <div class="checkout-address-box half">
	                      <input type="text" name="" placeholder="Exp Date" class="input-style"> 
	                    </div>
	                    <div class="checkout-address-box half">
	                      <input type="text" name="" placeholder="CVV" class="input-style"> 
	                    </div>	
	                    <div class="ashton-hero-top-payment-btn">
	                    	<a href="#">Save & Continue</a>
	                    </div>
            		</div>
            	</div>
            </div>
         </div>
      </div>
     
    </section><!-- page ends-->